import { Client } from '@nio-fe/liquor-client';

export class TransformersClient extends Client {
  constructor() {
    super(`/transformers`, {
      requestOptions: {
        withCredentials: true,
      },
    });
  }
  searchColleague(options) {
    return this.get('/v1/people', options);
  }
}
